var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7656 13.7451H41.2759",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8297 58.3242H17.2538C15.0249 58.3242 13.25 56.5493 13.25 54.3204V11.5174C13.25 9.28853 15.0249 7.51367 17.2538 7.51367H48.8297C51.0586 7.51367 52.8335 9.28853 52.8335 11.5174V54.3204C52.8335 56.508 51.0174 58.3242 48.8297 58.3242Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9827 53.7827C34.3732 53.7827 35.5005 52.6555 35.5005 51.2649C35.5005 49.8743 34.3732 48.7471 32.9827 48.7471C31.5921 48.7471 30.4648 49.8743 30.4648 51.2649C30.4648 52.6555 31.5921 53.7827 32.9827 53.7827Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.19797c5af7d4779a660b1a8df2136153.svg";
export { ForwardRef as ReactComponent };